export const FINANCE_EVENT_NAMES = [
  "finance.invoice.created",
  "finance.invoice.sent",
  "finance.invoice.viewed",
  "finance.invoice.paid",
  "finance.invoice.voided",
  "finance.invoice.overdue",
  "finance.payment_intent.created",
  "finance.payment_intent.confirmed",
  "finance.payment_intent.failed",
  "finance.payment.captured",
  "finance.payment.settled",
  "finance.payment.failed",
  "finance.refund.initiated",
  "finance.refund.completed",
  "finance.refund.failed",
  "finance.payout.created",
  "finance.payout.in_transit",
  "finance.payout.settled",
  "finance.payout.failed",
] as const;

export type FinanceEventName = (typeof FINANCE_EVENT_NAMES)[number];

export const FINANCE_EVENT_NAME_SET = new Set<string>(FINANCE_EVENT_NAMES);

export function isFinanceEventName(value: string): value is FinanceEventName {
  return FINANCE_EVENT_NAME_SET.has(value);
}

export const FINANCE_EVENT_FAMILY_BY_PREFIX: Record<string, string> = {
  "finance.invoice.": "invoice",
  "finance.payment_intent.": "payment_intent",
  "finance.payment.": "payment",
  "finance.refund.": "refund",
  "finance.payout.": "payout",
};

export function getFinanceEventFamily(eventName: FinanceEventName): string {
  for (const [prefix, family] of Object.entries(FINANCE_EVENT_FAMILY_BY_PREFIX)) {
    if (eventName.startsWith(prefix)) {
      return family;
    }
  }
  return "unknown";
}
